import { Controller } from "@hotwired/stimulus"

export default class FlashMessageController extends Controller {
  connect() {
    setTimeout(() => {
      this.element.remove()
    }, 5000)
  }
}